import {
    CancelRounded,
    CheckCircleRounded,
    ChangeCircleRounded,
    EditNoteRounded,
    HourglassTopRounded,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import AcxChip from "components/UI/AcxChip";
import { ApprovalStatus } from "models/LLMs/LLMClassifierApproval";
import { approvalStatusLabel } from "../../utils/llmClassifierApproval";

/** The compact version list has no room for the wording, so the status rides on an icon. */
export function ApprovalStatusIcon(props: { status?: ApprovalStatus }) {
    const label = approvalStatusLabel(props.status);
    const { Icon, color } = (() => {
        switch (props.status ?? ApprovalStatus.Draft) {
            case ApprovalStatus.AwaitingApproval:
                return { Icon: HourglassTopRounded, color: "yellow.dark" };
            case ApprovalStatus.Approved:
                return { Icon: CheckCircleRounded, color: "green.dark" };
            case ApprovalStatus.Rejected:
                return { Icon: CancelRounded, color: "red.dark" };
            case ApprovalStatus.ChangesRequested:
                return { Icon: ChangeCircleRounded, color: "orange.main" };
            default:
                return { Icon: EditNoteRounded, color: "gray.500" };
        }
    })();

    return (
        <Tooltip title={label}>
            <Icon
                fontSize="small"
                role="img"
                aria-label={label}
                sx={{ color, flexShrink: 0 }}
            />
        </Tooltip>
    );
}

export function ApprovalStatusChip(props: { status?: ApprovalStatus }) {
    const color = (() => {
        switch (props.status ?? ApprovalStatus.Draft) {
            case ApprovalStatus.AwaitingApproval:
                return "yellow" as const;
            case ApprovalStatus.Approved:
                return "green" as const;
            case ApprovalStatus.Rejected:
                return "red" as const;
            case ApprovalStatus.ChangesRequested:
                return "orange" as const;
            default:
                return "lightGray" as const;
        }
    })();

    return (
        <AcxChip
            size="small"
            color={color}
            label={approvalStatusLabel(props.status)}
        />
    );
}
